import classNames from "classnames";

import {SearchComboboxSpinnerIcon} from "../icons/SearchComboboxSpinnerIcon";
import type {ISearchComboboxSpinnerProps} from "../types/ISearchComboboxSpinnerProps";

import * as styles from "./SearchComboboxSpinner.module.css";

/** A 270° gray-700 arc turning in place; static when the user prefers reduced motion. */
export const SearchComboboxSpinner = (props: ISearchComboboxSpinnerProps) => {
    const {size = 22, className, dataTestId} = props;

    return (
        <span className={classNames(styles.spinner, className)} data-testid={dataTestId} aria-hidden="true">
            <SearchComboboxSpinnerIcon size={size} className={styles.arc} />
        </span>
    );
};
import classNames from "classnames";

import {SearchComboboxSpinnerIcon} from "../icons/SearchComboboxSpinnerIcon";
import type {ISearchComboboxSpinnerProps} from "../types/ISearchComboboxSpinnerProps";

import * as styles from "./SearchComboboxSpinner.module.css";

/** A 270° gray-700 arc turning in place; static when the user prefers reduced motion. */
export const SearchComboboxSpinner = (props: ISearchComboboxSpinnerProps) => {
    const {size = 22, className, dataTestId} = props;

    return (
        <span className={classNames(styles.spinner, className)} data-testid={dataTestId} aria-hidden="true">
            <SearchComboboxSpinnerIcon size={size} className={styles.arc} />
        </span>
    );
};
